import * as React from 'react';
import './Accounts.scss';

import ReactTable, { ReactTableDefaults } from 'react-table';

import { UserType, User, ToastState, Store, Channel } from 'types';
import { IoEdit } from 'react-icons/lib/io';

import Select from 'react-select';
import 'react-select/dist/react-select.css';

import { UserService, StoreService, ChannelService } from 'services/ApiService';

import Toast from 'components/Toast';
import { LoadHolder } from 'components/Loader';
import Modal from 'components/Modal';
import { ExportToCsv } from 'export-to-csv';
import { SearchFilter, TooltipCell, TooltipHeader } from 'helpers/Table';

var AccColumns = (updateUser: Function) => [
  {
    Header: <TooltipHeader value="Employee Name" />,
    accessor: 'contactName',
    filterMethod: (filter, row) => {
      if (row[filter.id]) {
        return row[filter.id].toLowerCase().includes(filter.value.toLowerCase());
      }
    },
    Filter: SearchFilter
  },
  {
    Header: <TooltipHeader value="Email" />,
    accessor: 'email',
    filterMethod: (filter, row) => {
      if (row[filter.id]) {
        return row[filter.id].toLowerCase().includes(filter.value.toLowerCase());
      }
    },
    Filter: SearchFilter
  },
  {
    id: 'editAcc',
    Header: <TooltipHeader value="Edit Account" />,
    filterable: false,
    sortable: false,
    accessor: props => {
      return (
        <button
          className="tableBtn"
          onClick={() => updateUser(props)}
        >
          <span><IoEdit /></span>
        </button>
      );
    }
  }
];

/* TODO: When implementing delete user, this can be used */
// {
//   id: 'deleteAcc',
//   Header: 'Delete Account',
//   accessor: props => {
//     return (
//       <button
//         className="tableBtn"
//         onClick={() => deleteUser(props.id)}
//       >
//         <span><IoTrashB /></span>
//       </button>
//     );
//   }
// }

var GrocerColumns = (updateUser: Function) => [
  {
    Header: <TooltipHeader value="Store Operator Number" />,
    accessor: 'store.storeOperatorNumber',
    Filter: SearchFilter
  },
  {
    Header: <TooltipHeader value="Store Operator Name" />,
    accessor: 'store.storeOperatorName',
    Filter: SearchFilter,
    filterMethod: (filter, row) => {
      if (row[filter.id]) {
        return row[filter.id].toLowerCase().includes(filter.value.toLowerCase());
      }
    },
  },
  ...AccColumns(updateUser),
];

var ReporterColumns = (updateUser: Function) => [
  {
    Header: <TooltipHeader value="Channels" />,
    accessor: 'channelNames',
    Filter: SearchFilter,
    filterMethod: (filter, row) => {
      if (row[filter.id]) {
        return row[filter.id].toLowerCase().includes(filter.value.toLowerCase());
      }
    },
  },
  ...AccColumns(updateUser),
];

class AccountsTable extends React.Component<{
  type: UserType,
  updateUser: Function,
  allUsers: User[],
  loading: boolean
}, {
  users: User[]
}> {
  constructor(props: {
    type: UserType,
    updateUser: Function,
    allUsers: User[],
    loading: boolean
  }) {
    super(props);
    this.state = {
      users: [],
    };
  }

  filterUsers = (newProps) => {
    this.setState({
      users: newProps.allUsers.filter(user => user.type === newProps.type)
    });
  }

  editUser = (user: User) => {
    UserService.update(user).then(() => {
      Toast.present({ message: 'User updated successfully' }, ToastState.SUCCESS);
    });
  }

  /*
   * TODO: a soft delete should be implemented in the future as a feature,
   * a user deletion feature is not implemented at the moement
   */
  // deleteUser = (id: number) => {
  //   this.setState({ loading: true }, () => {
  //     UserService.deleteUser(id).then(() => {
  //       this.setState({ loading: false });
  //       Toast.present({ message: 'User deleted successfully' }, ToastState.SUCCESS);
  //     }).catch(err => {
  //       this.setState({ loading: false });
  //       Toast.throw({ message: err.message });
  //     });
  //   });
  // }

  componentWillReceiveProps(newProps: { type: UserType }) {
    this.filterUsers(newProps);
  }

  render() {
    const { users } = this.state;
    var columns = AccColumns(this.props.updateUser);
    if (this.props.type === UserType.Grocery) {

      return (
        <div>
          <ReactTable
            loading={this.props.loading}
            minRows={0}
            defaultPageSize={10}
            filterable={true}
            data={users}
            columns={GrocerColumns(this.props.updateUser)}
            column={{
              ...ReactTableDefaults.column,
              Cell: TooltipCell
            }}
          />
        </div>
      );

    }
    if (this.props.type === UserType.LCBOReporter || UserType.GrocerReporter) {
      // columns = ReporterColumns(this.props.updateUser);
      return (
        <div>
          <ReactTable
            loading={this.props.loading}
            minRows={0}
            defaultPageSize={10}
            filterable={true}
            data={users}
            columns={ReporterColumns(this.props.updateUser)}
            column={{
              ...ReactTableDefaults.column,
              Cell: TooltipCell,
            }}
          />
        </div>
      );
    }

    return (
      <div>
        <ReactTable
          loading={this.props.loading}
          minRows={0}
          defaultPageSize={10}
          filterable={true}
          data={users}
          columns={columns}
          column={{
            ...ReactTableDefaults.column,
            Cell: TooltipCell
          }}
        />
      </div>
    );
  }
}

export default class Accounts extends React.Component<{}, {
  tab: UserType,
  showModal: boolean,
  showDeactivateUserModal: boolean,
  openUser: User | null,
  allUsers: User[],
  loading: boolean,
  storeOptions: { value: number, label: string }[],
  channelOptions: { value: number, label: string }[],
  authenticatedUserType: UserType | null,
}> {
  constructor(props: {}) {
    super(props);
    this.state = {
      tab: UserType.LCBO,
      showModal: false,
      showDeactivateUserModal: false,
      openUser: null,
      allUsers: [],
      loading: false,
      storeOptions: [],
      channelOptions: [],
      authenticatedUserType: null,
    };
  }

  openTab = (tab: UserType) => {
    this.setState({ tab });
  }

  openModal = () => {
    this.setState({ showModal: true });
  }

  openDeactivateUserModal = () => {
    this.setState({ showDeactivateUserModal: true });
  }

  hideModal = () => {
    this.setState({ showModal: false });
  }

  hideDeactivateUserModal = () => {
    this.setState({ showDeactivateUserModal: false });
  }

  createUser = (user: User | null) => {
    this.setState({ openUser: null });
    if (user !== null) {
      this.setState({
        openUser: {
          type: user.type,
          email: user.email,
          id: user.id,
          contactName: user.contactName,
          store: user.store,
          channels: user.channels
        } as User
      });
    } else {
      this.setState({
        openUser: {
          type: this.state.authenticatedUserType === UserType.Admin ? UserType.Grocery : UserType.QAAdmin,
          email: '',
          id: -1,
          password: '',
          contactName: ''
        } as User
      });
    }

    this.openModal();
  }

  saveUser = () => {
    this.setState({ loading: true });
    const currentUser = this.state.openUser;
    if (currentUser) {
      if (currentUser.id === -1) {
        UserService.createUser(currentUser).then(() => {
          this.setState({ loading: false, openUser: null });
          Toast.present({ message: 'User created successfully' }, ToastState.SUCCESS);
          this.reload();
        }).catch(err => {
          this.setState({ loading: false });
        });
      } else {
        UserService.update(currentUser, currentUser.id).then(() => {
          this.setState({ loading: false, openUser: null });
          Toast.present({ message: 'User updated successfully' }, ToastState.SUCCESS);
          this.reload();
        }).catch(err => {
          this.setState({ loading: false });
        });
      }
    }
  }

  onChange = (property: string, e) => {
    const { openUser } = this.state;
    const element = (e === null) ? '' : e;
    if (property !== 'store' && property !== 'channel') openUser!![property] = element.target.value;
    else if (property === 'store') openUser!!.store = { id: Number(element.value) } as Store;
    else {
      let channels: Channel[] = [];
      for (const eachElement of element) {
        const channel = { id: Number(eachElement.value) } as Channel;
        channels.push(channel);
      }
      openUser!!.channels = channels;
    }
    this.setState({ openUser });
  }

  reload = async () => {
    const currentType = UserService.getType();
    this.setState({ loading: true, authenticatedUserType: currentType, tab: currentType === UserType.QAAdmin ? UserType.QAAdmin : UserType.LCBO});
    UserService.getAllUsers().then(users => {
      for (let user of users) {
        for (let channel of user.channels) {
          if (channel.channelName) {
            user.channelNames = user.channelNames ? user.channelNames : '';
            user.channelNames = user.channelNames + ((user.channelNames === '') ? '' : ', ') + channel.channelName;
          }
        }
      }
      this.setState({ allUsers: users, loading: false });
    }).catch(err => {
      this.setState({ loading: false });
    });
  }

  deactivateUser = () => {
    this.setState({ loading: true });
    const currentUser = this.state.openUser;
    if (currentUser) {
      UserService.deactivateUser(currentUser.id).then(() => {
        this.hideModal();
        this.hideDeactivateUserModal();
        this.setState({ loading: false, openUser: null});
        Toast.present({ message: 'User deleted successfully' }, ToastState.SUCCESS);
        this.reload();
      }).catch(err => {
        this.setState({ loading: false });
      });
    }
  }

  componentDidMount() {
    this.reload();
    StoreService.fetchAll().then(stores => {
      this.setState({
        storeOptions: stores.map(store => ({
          value: store.id,
          label: store.storeOperatorName + ' #' + store.storeOperatorNumber
        }))
      });
    });
    ChannelService.fetchAll().then(channels => {
      this.setState({
        channelOptions: channels.map(channel => ({
          value: channel.id,
          label: channel.channelName
        }))
      });
    });
  }
  addLeadingZero(time: Number) {
    let str = time.toString();
    if (str.length < 2) {
      return '0' + str;
    }
    return str;
  }
  createFileName() {
    let today = new Date();
    let year = today.getFullYear();
    let day = this.addLeadingZero(today.getDate());
    let month = this.addLeadingZero(today.getMonth() + 1);
    let hour = this.addLeadingZero(today.getHours());
    let minute = this.addLeadingZero(today.getMinutes());
    let seconds = this.addLeadingZero(today.getSeconds());

    let dateName = `${year}-${month}-${day}__${hour}.${minute}.${seconds}EST`;

    return dateName;
  }

  format = (data: any[]) => {

    return data.map(item => {
      return ([
        { text: item.contactName },
        { text: item.email },
        { text: item.store.storeOperatorNumber },
        { text: item.store.storeOperatorName },

      ]);
    });

  }

  async downloadAsCsv() {
    let dateName = this.createFileName();
    const options = {
      fieldSeparator: ',',
      filename: `LCO_Accounts_Export__${dateName}`,
      quoteStrings: '"',
      decimalseparator: '.',
      showLabels: true,
      showTitle: false,
      useBom: false,
      useKeysAsHeaders: true,
    };
    const csvExporter = new ExportToCsv(options);

    let cleanedClaims = this.cleanDataForCsv();
    if (cleanedClaims.length < 1) {
      Toast.present({ message: 'Can not export empty accounts lists' }, ToastState.ERROR);
    } else {
      try {
        csvExporter.generateCsv(cleanedClaims);
        Toast.present({ message: 'Accounts has been succesfully exported' }, ToastState.SUCCESS);
      } catch (err) {
        Toast.present({ message: 'Claims has failed to be exported' }, ToastState.ERROR);
      }
    }
  }

  cleanDataForCsv() {
    /* tslint:disable:no-string-literal */

    let users = this.state.allUsers.filter(user => user.type === UserType.Grocery);

    users.map(async obj => {

      obj['ContactName'] = obj['contactName'];
      obj['Email'] = obj['email'];
      obj['StoreOperatorNumber'] = obj['store']['storeOperatorNumber'];
      obj['StoreOperatorName'] = obj['store']['storeOperatorName'];

      Object.keys(obj).forEach((key) => {
        if (key.charAt(0) === key.charAt(0).toLowerCase()) {
          delete obj[key];
        }
      });
    });

    return users;
    /* tslint:enable:no-string-literal */
  }

  render() {
    const { tab, showModal, showDeactivateUserModal, openUser, allUsers, loading, storeOptions,
      channelOptions } = this.state;
    const AVAILABLE_TYPES = {
      [UserType.Admin]: [
        {label: 'LCO', value: UserType.Grocery}, 
        {label: 'LCBO Employee', value: UserType.LCBO}, 
        {label: 'Admin', value: UserType.Admin}, 
        {label: 'LCBO Reporter', value: UserType.LCBOReporter}, 
        {label: 'LCO Reporter', value: UserType.GrocerReporter} 
      ],
      [UserType.QAAdmin]: [
        {label: 'QA Admin', value: UserType.QAAdmin} 
      ]
    };
    let channelMultiSelectVal: number[] = [];
    if (openUser && openUser.channels) {
      for (let channel of openUser.channels) {
        channelMultiSelectVal.push(channel.id);
      }
    }
    return (
      <div className="accounts">
        <h1>Accounts</h1>
        <button
          className="createAcc"
          onClick={() => this.createUser(null)}
        >
          Create New Account
        </button>

        {this.state.authenticatedUserType === UserType.Admin && <button
          className="createAcc"
          onClick={() => this.downloadAsCsv()}
        >
          Export LCO Accounts
        </button>}
        <div className="box">
          <div className="tabs">
            
            {this.state.authenticatedUserType === UserType.Admin ? <><button
              onClick={this.openTab.bind(this, UserType.Grocery)}
              className={'tab' + (tab === UserType.Grocery ? ' active' : '')}
            >
              <span>LCO Accounts</span>
            </button>
            <button
              onClick={this.openTab.bind(this, UserType.LCBO)}
              className={'tab' + (tab === UserType.LCBO ? ' active' : '')}
            >
              <span>LCBO Accounts</span>
            </button>
            <button
              onClick={this.openTab.bind(this, UserType.Admin)}
              className={'tab' + (tab === UserType.Admin ? ' active' : '')}
            >
              <span>Admin Accounts</span>
            </button>
            <button
              onClick={this.openTab.bind(this, UserType.LCBOReporter)}
              className={'tab' + (tab === UserType.LCBOReporter ? ' active' : '')}
            >
              <span>LCBO Reporter Accounts</span>
            </button>
            <button
              onClick={this.openTab.bind(this, UserType.GrocerReporter)}
              className={'tab' + (tab === UserType.GrocerReporter ? ' active' : '')}
            >
              <span>LCO  Reporter Accounts</span>
            </button></>
            :
            <button
              onClick={this.openTab.bind(this, UserType.QAAdmin)}
              className={'tab' + (tab === UserType.QAAdmin ? ' active' : '')}
            >
              <span>QA Admins</span>
            </button>}
          </div>
        </div>
        <div className="content">
          <AccountsTable
            type={tab}
            updateUser={this.createUser}
            allUsers={allUsers}
            loading={loading}
          />
        </div>
        {openUser ?
          <Modal visible={showModal} onClose={this.hideModal}>
            <div className="account-modal">
              <h2>
                {openUser.id === -1 ? 'Create A New User' : 'Edit User'}
              </h2>
              <label>Name</label>
              <input
                disabled={loading}
                placeholder="Name"
                onChange={this.onChange.bind(this, 'contactName')}
                value={openUser.contactName}
              />
              <label>Email</label>
              <input
                disabled={loading}
                placeholder="Email"
                onChange={this.onChange.bind(this, 'email')}
                value={openUser.email}
              />
              <label>{openUser.id === -1 ? 'Password' : 'New Password'}</label>
              <input
                disabled={loading}
                placeholder={openUser.id === -1 ? 'Password' : 'New Password'}
                type="password"
                onChange={this.onChange.bind(this, 'password')}
                value={openUser.password ? openUser.password : ''}
              />

              <label>Type</label>
              <select
                disabled={loading}
                onChange={this.onChange.bind(this, 'type')}
                value={openUser.type}
              >
                {AVAILABLE_TYPES[this.state.authenticatedUserType ? this.state.authenticatedUserType : UserType.Admin].map(({label, value}) => (
                  <option value={value}>{label}</option>
                ))}
              </select>

              {
                openUser.type !== UserType.Grocery ? null :
                  <>
                    <label>Store</label>
                    <Select
                      disabled={loading}
                      options={storeOptions}
                      value={openUser.store ? openUser.store.id : null}
                      onChange={this.onChange.bind(this, 'store')}
                    />
                  </>
              }
              {
                openUser.type !== UserType.GrocerReporter ? null :
                  <>
                    <label>Channels</label>
                    <Select
                      multi={true}
                      disabled={loading}
                      options={channelOptions}
                      placeholder="Select one or more channel(s)"
                      value={channelMultiSelectVal}
                      onChange={this.onChange.bind(this, 'channel')}
                    />
                  </>
              }
              {
                openUser.type !== UserType.LCBOReporter ? null :
                  <>
                    <label>Channels</label>
                    <Select
                      multi={true}
                      disabled={loading}
                      options={channelOptions}
                      placeholder="Select one or more channel(s)"
                      value={channelMultiSelectVal}
                      onChange={this.onChange.bind(this, 'channel')}
                    />
                  </>
              }
              <button disabled={loading} onClick={this.saveUser}>
                {openUser.id === -1 ? 'Create User' : 'Save'}
              </button>
              {
                openUser.id === -1 ? null :
                  <>
                    <button disabled={loading} onClick={this.openDeactivateUserModal}>
                      {'Delete'}
                    </button>
                  </>
              }
              <LoadHolder loading={loading} />
            </div>
          </Modal> : null
        }
        {openUser ?
          <Modal visible={showDeactivateUserModal} onClose={this.hideDeactivateUserModal}>
            <div className="account-modal">
              <h2>
                {'Remove User?'}
              </h2>
              <button disabled={loading} onClick={this.deactivateUser}>
                {'Delete'}
              </button>
              <button disabled={loading} onClick={this.hideDeactivateUserModal}>
                {'Cancel'}
              </button>
              <LoadHolder loading={loading} />
            </div>
          </Modal> : null
        }
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/views/Accounts/index.tsx